import { useCallback, useEffect, useState } from 'react';

export const useStepOnboarding = (key: string, steps: string[]) => {
  const [stepIndex, setStepIndex] = useState<number | null>(null);

  useEffect(() => {
    const seen = localStorage.getItem(key);
    if (!seen) {
      setStepIndex(0);
    }
  }, [key]);

  const next = () => {
    if (stepIndex === null) return;
    if (stepIndex + 1 >= steps.length) {
      localStorage.setItem(key, 'true');
      setStepIndex(null);
    } else {
      setStepIndex(stepIndex + 1);
    }
  };

  const restart = useCallback(() => {
    localStorage.removeItem(key);
    setStepIndex(0);
  }, [key]);

  return {
    stepIndex,
    currentSelector: stepIndex !== null ? steps[stepIndex] : null,
    next,
    restart,
  };
};
